export const VideoPages = {
  DETAILS: 'details',
  ANALYTICS: 'analytics',
  TRIM: 'trim',
  SEND_AND_SHARE: 'send-and-share',
  FOLDER_SHARE: 'folder-share',
  FOLDER_SHARE_OEM: 'folder-share-oem',
};

export const ArchiveView = [
  {
    value: '1',
    text: 'Yes',
  },
  {
    value: '0',
    text: 'No',
  },
];

export enum ShareWithTarget {
  Customer = 'customer',
  Reseller = 'reseller',
  EntireOrganization = 'Entire Organization',
}
